// --------------------------------------------------------------
// Created On: 2026-10-13
// Author: Zachary Thomas
//
// Last Modified: 2026-10-30
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants that represents the different feature flags that can be assigned to a company.
export const SYSTEM_CONTROL_FEATURE_FLAG = "COMMAND_CENTER";
export const AI_AGENT_FEATURE_FLAG = "LLM_AGENT";
